import React from 'react';
import { Link, useLocation } from 'react-router-dom';

/**
 * Sidebar di navigazione principale.
 * Mostra collegamenti alle sezioni Upload e Partite.
 * Visibile su tutte le pagine (al momento solo due voci, espandibile in futuro).
 */
const Sidebar: React.FC = () => {
  const location = useLocation();

  const navItems = [
    { path: '/', label: 'Carica Video', icon: '📤' },
    { path: '/history', label: 'Partite', icon: '🏐' },
  ];

  const linkStyle = (path: string): React.CSSProperties => ({
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    padding: '0.6rem 1rem',
    textDecoration: 'none',
    color: location.pathname === path ? '#ffffff' : '#cbd5e1',
    backgroundColor: location.pathname === path ? '#334155' : 'transparent',
    borderRadius: '0.5rem',
    fontWeight: 500,
    fontSize: '0.9rem',
    transition: 'all 0.2s',
  });

  return (
    <aside
      style={{
        width: '220px',
        minHeight: 'calc(100vh - 60px)',
        backgroundColor: '#1e293b',
        padding: '1.5rem 0.75rem',
        display: 'flex',
        flexDirection: 'column',
        gap: '0.25rem',
        borderRight: '1px solid #334155',
      }}
    >
      <nav style={{ display: 'flex', flexDirection: 'column', gap: '0.25rem' }}>
        {navItems.map((item) => (
          <Link key={item.path} to={item.path} style={linkStyle(item.path)}>
            <span>{item.icon}</span>
            <span>{item.label}</span>
          </Link>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;